// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"85f2b963","530":"6f9f40c2"}[chunkId] + ".chunk.js";
};